module.exports = __webpack_public_path__ + "img/Contentos_logo.33fc3363.svg";